<template>
  <tr>
    <td>
      <a href="">{{ signalQuery.name }}</a>
    </td>
    <td class="compact text-center" v-if="displayInterval">{{ signalQuery.interval_description }}</td>
    <td class="compact text-center" v-if="displayInterval && (signalQuery.recurring == '1')">
      Terugkerend
    </td>
    <td class="compact text-center" v-else-if="displayRecurring">
      Eenmalig
    </td>
    <td class="compact text-center" v-if="displayUsersCount">{{ signalQuery.users_count }}</td>
    <td class="compact text-center" v-if="displayDepartmentsCount">{{ signalQuery.departments_count }}</td>
    <td class="compact text-center" v-if="displaySignalsCount">{{ signalQuery.signal_count }}</td>
    <td class="compact text-center" v-if="displayAutoProcess">
      {{ parseAutoProcessDays(signalQuery) }}
    </td>
    <td class="compact text-center" v-if="displayVisibleForCustomer">
      {{ signalQuery.visible_for_customer | toYesNo }}
    </td>
    <td class="compact">
            <div class="pull-right">
      <a-tooltip placement="left" v-if="canEdit">
        <template slot="title">
          <span>Signaal bewerken</span>
        </template>
        <a-button type="primary" v-on:click.stop="onEditClick(signalQuery.id)">
          <pencil-icon></pencil-icon>
        </a-button>
      </a-tooltip>
      <a-popconfirm @confirm="onDetachFromSignal(signalQuery.id)"
                    cancel-text="Nee"
                    ok-text="Ja"
                    placement="topRight"
                    title="Weet u zeker dat u zich voor dit signaal wilt afmelden."
                    v-if="canDetachUser && !isDetached"
                    v-on:click.stop
      >
        <a-tooltip placement="left">
          <template slot="title">
            <span>Mij afmelden voor het signaal</span>
          </template>
          <a-button type="danger" v-on:click.stop>
            <close-octagon-icon></close-octagon-icon>
          </a-button>
        </a-tooltip>
      </a-popconfirm>
      <a-tooltip placement="left" v-else-if="displayDetachDepartmentMessage">
        <template slot="title">
          <span>U krijgt dit signaal via een afdeling. Om dit te veranderen moet u de afdeling verlaten of moet de afdeling bij het signaal worden verwijderd. Overleg met de beheerder wat het handigst is in uw situatie</span>
        </template>
        <a-button type="disabled" v-on:click.stop>
          <close-octagon-icon></close-octagon-icon>
        </a-button>
      </a-tooltip>
      <a-popconfirm v-if="canDeleteSignal"
                    @confirm="onDeleteSignal()"
                    cancel-text="Nee"
                    ok-text="Ja"
                    placement="topRight"
                    title="Weet u zeker dat u dit signaal wilt verwijderen? ALLE signalen die hieraan gekoppeld zijn zullen verdwijnen."
                    v-on:click.stop
      >
        <a-tooltip placement="left">
          <template slot="title">
            <span>Signaal verwijderen</span>
          </template>
          <a-button type="danger" v-on:click.stop>
            <delete-icon></delete-icon>
          </a-button>
        </a-tooltip>
      </a-popconfirm>
            </div>
    </td>
  </tr>
</template>

<script>
import signalQueryApi from '~/api/signalQuery'

export default {
  name: "SignalQueryRowComponent",
  props: {
    query: {
      type: Object,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    displayInterval: {
      type: Boolean,
      required: false,
      default: true
    },
    displayRecurring: {
      type: Boolean,
      required: false,
      default: true
    },
    displayUsersCount: {
      type: Boolean,
      required: false,
      default: true
    },
    displayDepartmentsCount: {
      type: Boolean,
      required: false,
      default: true
    },
    displaySignalsCount: {
      type: Boolean,
      required: false,
      default: true
    },
    displayAutoProcess: {
      type: Boolean,
      required: false,
      default: true
    },
    displayVisibleForCustomer: {
      type: Boolean,
      required: false,
      default: true
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: true
    },
    canDetachUser: {
      type: Boolean,
      required: false,
      default: false
    },
    canDeleteSignal: {
      type: Boolean,
      required: false,
      default: false
    },
    displayDetachDepartmentMessage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      signalQuery: this.query,
      isDetached: false
    }
  },
  methods: {
    parseAutoProcessDays(query) {
      if ((query.auto_process === 1) && (query.process_after > 0)) {
        if (query.process_after === 1) {
          return 'Na 1 dag'
        }
      } else if (query.process_after > 1) {
        return 'Na ' + query.process_after + ' dagen';
      }

      return 'Nee'
    },
    onEditClick(id) {
      window.location.href = '/signal/query/' + id + '/edit';
    },
    onDetachFromSignal(id) {
      signalQueryApi.detachUserFromQuery(this.userId, id).then(() => {
        this.reloadQuery();
        this.isDetached = true;
      })
    },
    onDeleteSignal() {
      signalQueryApi.deleteSignalFromQuery(this.signalQuery.id).then(() => {
        this.$emit('deleted')
      }).catch(error => {
        const err = error.response.data;
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: err.status === 403 ? err.message : 'Er is iets fout gegaan bij het verwijderen van het signaal.',
        });
      })
    },
    reloadQuery() {
      signalQueryApi.get(this.signalQuery.id).then((response) => {
        this.signalQuery = response.data;
      })
    }
  }
}
</script>

<style scoped>

</style>